<template>
    <div class="custom-el-wrapper">
        <div class="ra-filter custom-form-wrap">
          <el-form inline size="mini">
                <el-form-item>
                  <el-input style="width: 200px;" v-model="searchParams.task_no" class="ra-filter__input" placeholder="检测编号" clearable></el-input>
                </el-form-item>
                <el-form-item>
                  <el-input style="width: 200px;" v-model="searchParams.remark" class="ra-filter__input" placeholder="关键词" clearable></el-input>
                </el-form-item>
<!--                <el-form-item :label="f.label" v-for="f in statusFilters" :key="f.field">
                  <el-select v-model="searchParams[f.field]" class="ra-filter__select" placeholder="全部" clearable >
                    <el-option v-for="item in check_status" :key="item.key" :label="item.value" :value="item.key" />
                  </el-select>
                </el-form-item>-->
                <el-form-item label="SKU异常">
                  <el-select v-model="searchParams.cloudEditSkuStatus" placeholder="请选择状态" clearable filterable multiple collapse-tags>
                    <el-option v-for="item in skuViolcationStatus" :key="item.value" :label="item.label" :value="item.value" />
                  </el-select>
                </el-form-item>
                <el-form-item label="状态">
                  <el-select v-model="searchParams.status" class="ra-filter__select" placeholder="全部" clearable >
                    <el-option v-for="item in process_status" :key="item.key" :label="item.value" :value="item.key" />
                  </el-select>
                </el-form-item>
              </el-form>
          <div class="ra-filter-opt">
                <button class="btn btn--primary"  @click="handleSearch">查询</button>
                <button class="btn" @click="refresh">重置</button>
                <span class="ra-filter__divider"></span>
                <button class="btn" @click="replaceSkuName">一键过滤</button>
                <button class="btn" @click="handleCloudBatchEdit">批量编辑</button>
                <button class="btn btn--danger" @click="batchDelete">批量删除异常SKU</button>
                <button class="btn btn--danger"  @click="batchoffline">批量下架</button>
            </div>
        </div>
      <div class="table-pager-wrap">
        <el-table v-loading="loading" :data="tableData" @selection-change="selectChange"
            :header-cell-style="{ background: 'rgb(245, 240, 232)', color: '#606266' }" class="rc_table" row-key="id">
            <el-table-column type="selection" align="center" width="50"></el-table-column>
            <el-table-column label="序号" type="index" align="center" width="50"></el-table-column>
            <el-table-column label="商品信息" min-width="220">
                <template #default="{ row }">
                    <div class="goods-box">
                      <el-popover
                          placement="top"
                          :fallback-placements="[ 'top', 'right', 'left','bottom']"
                          width="350"
                          trigger="hover" :disabled="!row.import_product.main_image">
                        <div class="popover-content">
                          <el-image :src="row.import_product.main_image" fit="contain" style="width:100%;height: auto"></el-image>
                        </div>
                        <div class="ra-goods__imgwrap" slot="reference">
                          <img :src="row.import_product.main_image" class="goods-img">
                        </div>
                      </el-popover>

                        <div class="goods-info">
                            <el-tooltip class="item" effect="dark" :content="row.import_product.title" placement="top"
                                :open-delay="300">
                                <div class="goods-title">{{ row.import_product.title }}</div>
                            </el-tooltip>
                            <div style="font-size: 10px;color: rgb(212, 169, 70);">价格：{{ row.import_product.price }}</div>
                            <div style="font-size: 10px;color: rgb(153, 153, 153);">来源ID：{{ row.import_product.source_product_id }}</div>
                            <div :class="skuStatus[row.import_product.sku_status].type">
                                {{ skuStatus[row.import_product.sku_status].label }}<span
                                    v-if="row.import_product.status === 4" class="offline-tag"> | 已下架</span></div>
                        </div>
                    </div>
                </template>
            </el-table-column>
            <el-table-column label="检测编号" prop="task_no" align="center" width="220"
                show-overflow-tooltip class-name="ra-col-no"></el-table-column>
            <el-table-column label="商品编号" prop="product_id" width="90" show-overflow-tooltip
                align="center"></el-table-column>
            <el-table-column label="关键词违规" align="center" show-overflow-tooltip min-width="150">
                <template #default="{ row }">
                    <el-tag size="small"
                        :type="check_status.find(s => s.key === row.sku_name_abnormal_words_check)?.type">
                        {{check_status.find(s => s.key === row.sku_name_abnormal_words_check)?.value}}
                    </el-tag>
                </template>
            </el-table-column>
            <el-table-column label="尺码违规" align="center" show-overflow-tooltip>
                <template #default="{ row }">
                    <el-tag size="small"
                        :type="check_status.find(s => s.key === row.sku_size_abnormal_words_check || s.key === 9)?.type">
                        {{check_status.find(s => s.key === row.sku_size_abnormal_words_check || s.key === 9)?.value}}
                    </el-tag>
                </template>
            </el-table-column>
            <el-table-column label="高价限制" align="center" show-overflow-tooltip>
                <template #default="{ row }">
                    <el-tag size="small" :type="check_status.find(s => s.key === row.sku_amount_max_limit_check)?.type">
                        {{check_status.find(s => s.key === row.sku_amount_max_limit_check)?.value}}
                    </el-tag>
                </template>
            </el-table-column>
            <el-table-column label="低价限制" align="center" show-overflow-tooltip>
                <template #default="{ row }">
                    <el-tag size="small" :type="check_status.find(s => s.key === row.sku_amount_min_limit_check)?.type">
                        {{check_status.find(s => s.key === row.sku_amount_min_limit_check)?.value}}
                    </el-tag>
                </template>
            </el-table-column>
            <el-table-column label="价格倍数差" align="center" show-overflow-tooltip min-width="100">
                <template #default="{ row }">
                    <el-tag size="small"
                        :type="check_status.find(s => s.key === row.sku_amount_max_min_gap_check)?.type">
                        {{check_status.find(s => s.key === row.sku_amount_max_min_gap_check)?.value}}
                    </el-tag>
                </template>
            </el-table-column>
            <el-table-column label="价格差" align="center" show-overflow-tooltip>
                <template #default="{ row }">
                    <el-tag size="small"
                        :type="check_status.find(s => s.key === row.sku_amount_max_min_gapmoney_check)?.type">
                        {{check_status.find(s => s.key === row.sku_amount_max_min_gapmoney_check)?.value}}
                    </el-tag>
                </template>
            </el-table-column>
            <el-table-column label="价格违规" align="center" show-overflow-tooltip>
                <template #default="{ row }">
                    <el-tag size="small" :type="check_status.find(s => s.key === row.sku_amount_abnormal_check)?.type">
                        {{check_status.find(s => s.key === row.sku_amount_abnormal_check)?.value}}
                    </el-tag>
                </template>
            </el-table-column>
            <el-table-column label="异常记录" width="150" align="center">
                <template #default="{ row }">
                    <!-- 关键：把 content 换成 html 插槽！ -->
                    <el-tooltip effect="dark" placement="top" :open-delay="300">
                        <!-- 表格内显示 3行，每行10字 -->
                        <div class="remark-multi-line">
                            <div v-for="(text, index) in formatRemark(row.remark, row.sku_amount_abnormal_remark)"
                                :key="index" v-if="index < 3">
                                {{ index + 1 }}. {{ text.length > 10 ? text.slice(0, 10) + '...' : text }}
                            </div>
                        </div>
                        <div slot="content" style="white-space: pre-line; text-align:left;">
                            <div v-for="(text, index) in formatRemark(row.remark, row.sku_amount_abnormal_remark)"
                                :key="index">
                                {{ index + 1 }}. {{ text }}
                            </div>
                        </div>
                    </el-tooltip>
                </template>
            </el-table-column>
            <el-table-column label="状态" align="center" show-overflow-tooltip>
                <template #default="{ row }">
                    <el-tag size="small" :type="process_status.find(s => s.key === row.status)?.type">
                        {{process_status.find(s => s.key === row.status)?.value}}
                    </el-tag>
                </template>
            </el-table-column>
            <el-table-column label="创建时间" width="160" prop="created_at" show-overflow-tooltip
                align="center">
                   <template #default="{ row }">
                     <span style="color: rgb(153, 153, 153);">{{row.created_at}}</span>
                   </template>
            </el-table-column>
            <el-table-column label="操作" align="center" width="80">
                <template #default="{ row }">
                    <el-button size="mini" type="primary" @click="handleEdit(row)">编辑</el-button>
                </template>
            </el-table-column>
        </el-table>

        <div class="ra-pager" >
            <!-- 左:总条数 + 每页条数 -->
            <div class="ra-pager__col ra-pager__col--left">
                <span class="ra-pager__total">共 <span class="ra-pager__num">{{ page_data.total }}</span> 条</span>
                <el-select size="mini" v-model="page_data.limit" @change="onPageSizeChange" style="width: 100px">
                  <el-option v-for="item in pageSizeOptions" :key="item" :value="item" :label="`${item} 条/页`"></el-option>
                </el-select>
            </div>
            <!-- 中:页码按钮组 -->
            <div class="ra-pager__col ra-pager__col--center custom-page-wrap">
                <el-pagination :total="page_data.total" :page-size="page_data.limit" :current-page="page_data.page"
                    layout="prev, pager, next" small @current-change="onPageChange" />
            </div>
            <!-- 右:跳转 -->
            <div class="ra-pager__col ra-pager__col--right">
                <span class="ra-pager__jump">
                    <span>前往</span>
                    <input v-model.number="jumpInput" class="ra-pager__input" @keyup.enter="onJump" />
                    <span>页</span>
                </span>
                <button class="ra-pager__ok" @click="onJump">确定</button>
            </div>
        </div>
      </div>

        <!-- 弹窗组件，传递API、全局提示、同步变量 -->
        <SKUEditDialog :visible.sync="cloudEditShow" :cloud-edit-mode="cloudEditMode" :cloud-edit-list="cloudEditList"
            :cloud-edit-source-list="cloudEditSourceList"/>

    </div>
</template>
<script>
import { mapActions } from "vuex";

import PageSizeSelect from "@/components/newUi/PageSizeSelect.vue";
import { getViolationWords } from "../../../api/main/ucenter";
import SKUEditDialog from "./skuEditDialog.vue";
export default {
    components: {
        PageSizeSelect, SKUEditDialog,
    },
    data() {
        return {
            selectedValues: [],
            name_words_options: [],
            size_words_options: [],
            dataInfo: {},
            tableData: [],
            skuCheckInfo: {},
            // 筛选区状态下拉配置（字段名与接口/行数据一致）
            statusFilters: [
                { label: '关键词违规', field: 'sku_name_abnormal_words_check' },
                { label: '尺码违规', field: 'sku_size_abnormal_words_check' },
                { label: '高价限制', field: 'sku_amount_max_limit_check' },
                { label: '低价限制', field: 'sku_amount_min_limit_check' },
                { label: '价格倍数差', field: 'sku_amount_max_min_gap_check' },
                { label: '价格差', field: 'sku_amount_max_min_gapmoney_check' },
                { label: '价格违规', field: 'sku_amount_abnormal_check' },
            ],
            skuStatus: {
                1: { label: '待替换', value: 1, type: 'skuStatus-wait' },
                2: { label: '已替换', value: 2, type: 'skuStatus-success' },
                3: { label: '找不到', value: 3, type: 'skuStatus-error' }
            },
            skuViolcationStatus: {
                1: { label: '关键词违规', value: 1, type: 'selected-tag' },
                2: { label: '尺码违规', value: 2, type: 'replaced-tag' },
                3: { label: '高价限制', value: 3, type: 'notFond-tag' },
                4: { label: '低价限制', value: 4, type: 'notFond-tag' },
                5: { label: '价格倍数差', value: 5, type: 'notFond-tag' },
                6: { label: '价格差', value: 6, type: 'notFond-tag' },
                //7: { label: '配件/耗材混卖', value: 7, type: 'notFond-tag' },
                //8: { label: '非商品SKU', value: 8, type: 'notFond-tag' },
                //9: { label: '异常拆分规格', value: 9, type: 'notFond-tag' },
                10: { label: '套装和单件混卖', value: 10, type: 'notFond-tag' },
                //11: { label: '孤立低价SKU', value: 11, type: 'notFond-tag' },
                12: { label: '低价SKU引流', value: 12, type: 'notFond-tag' },
                //13: { label: '铺货价与最低铺货价不一致。', value: 13, type: 'notFond-tag' },
                // 19: { label: '完成整改', value: 19, type: 'notFond-tag' },
            },
            check_status: [
                { key: 1, value: '正常', type: 'success' },
                { key: 2, value: '异常', type: 'danger' },
                { key: 9, value: '不检测', type: 'info' },
            ],
            process_status: [
                { key: 1, value: '待处理', type: 'warning' },
                { key: 2, value: '已处理', type: 'success' },
                { key: 9, value: '处理异常', type: 'danger' },
            ],
            pageSizeOptions: [10, 20, 50, 100, 200, 500, 1000],
            jumpInput: 1,
            page_data: {
                limit: 10,
                page: 1,
                total: 0,
            },
            searchParams: {
                task_no: '',
                name_words: '',
                size_words: '',
          /*      sku_name_abnormal_words_check: '',
                sku_size_abnormal_words_check: '',
                sku_amount_max_limit_check: '',
                sku_amount_min_limit_check: '',
                sku_amount_max_min_gap_check: '',
                sku_amount_max_min_gapmoney_check: '',
                sku_amount_abnormal_check: '',*/
                cloudEditSkuStatus: [],
                remark: '',
                status: '',
            },
            selectData: [],
            loading: false,
            cloudEditShow: false,
            cloudEditMode: 'single',
            cloudEditList: [],
            cloudEditSourceList: [],
        }
    },
    created() {
        // this.initData()
    },
    mounted() {
        this.searchParams.task_no = this.$route.query.task_no
        if (this.searchParams.task_no) {
            this.handleSearch()
        }
        // this.getViolationWords()
    },
    methods: {
        ...mapActions({
            opGetSkudetectionDetailPage: 'ucenter/opGetSkudetectionDetailPage',
            opDelSkudetectionDetail: 'ucenter/opDelSkudetectionDetail',
            opOfflineSkudetection: 'ucenter/opOfflineSkudetection',
            opGetViolationWords: 'ucenter/opGetViolationWords',
            opPutReplaceSkuName: 'ucenter/opPutReplaceSkuName',
        }),
        initData(task_no) {
            if (task_no) {
                this.searchParams.task_no = task_no
                this.handleSearch()
            } else {
                this.refresh()
            }

        },
        refresh() {
            this.page_data.page = 1
            this.page_data.total = 0
            this.jumpInput = 1
            this.searchParams = {
                task_no: '',
                name_words: '',
                size_words: '',
              /*  sku_name_abnormal_words_check: '',
                sku_size_abnormal_words_check: '',
                sku_amount_max_limit_check: '',
                sku_amount_min_limit_check: '',
                sku_amount_max_min_gap_check: '',
                sku_amount_max_min_gapmoney_check: '',
                sku_amount_abnormal_check: '',*/
                cloudEditSkuStatus: [],
                remark: '',
                status: '',
            }
            this.getDataList()
        },
        handleSearch() {
            this.page_data.page = 1
            this.jumpInput = 1
            this.getDataList()
        },
        onPageChange(page) {
            this.page_data.page = page
            this.jumpInput = page
            this.getDataList()
        },
        onPageSizeChange(limit) {
            this.page_data.limit = limit
            this.page_data.page = 1
            this.jumpInput = 1
            this.getDataList()
        },
        onJump() {
            const max = Math.max(1, Math.ceil(this.page_data.total / this.page_data.limit))
            const target = Math.min(Math.max(parseInt(this.jumpInput, 10) || 1, 1), max)
            this.jumpInput = target
            this.page_data.page = target
            this.getDataList()
        },
        selectChange(e) {
            this.selectData = [...e]
        },
        //获取检测列表
        getDataList() {
            this.loading = true
            let param = { page_size: this.page_data.limit, page: this.page_data.page, ...this.searchParams }
            this.opGetSkudetectionDetailPage({
                data: param,
                success: (res) => {
                    this.loading = false
                    // console.log(res)
                    if (res.code == 200) {
                        this.tableData = res.data.list
                        this.page_data.total = res.data.total
                    } else {
                        this.$message.error(res.message)
                    }

                }
            })
        },
        //批量删除
        batchDelete() {
            if (this.selectData.length == 0 && this.searchParams.task_no == '') {
                this.$message.error('请选择异常sku信息，或填写检测编号');
                return
            }
            let messagetitle = `是否确定删除${this.selectData.length}个异常sku?`
            if (this.selectData.length == 0 && this.searchParams.task_no != '') {
                messagetitle = `检测编号:${this.searchParams.task_no},将批量删除全部异常sku`
            }

            this.$confirm(messagetitle, '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.opDelSkudetectionDetail({
                    data: { ids: this.selectData.map(item => item.id).join(','), task_no: this.searchParams.task_no },
                    success: (res) => {
                        if (res.code == 200) {
                            this.$message.success('删除成功，' + res.data + 'sku')
                            this.getDataList()
                        } else {
                            this.$message.error(res.message)
                        }
                    }
                })
            })
        },
        //批量删除
        replaceSkuName() {
            if (this.selectData.length == 0 && this.searchParams.task_no == '') {
                this.$message.error('请选择异常sku信息，或填写检测编号');
                return
            }
            let messagetitle = `是否确定过滤${this.selectData.length}个异常sku?`
            if (this.selectData.length == 0 && this.searchParams.task_no != '') {
                messagetitle = `检测编号:${this.searchParams.task_no},将批量过滤全部异常sku`
            }

            this.$confirm(messagetitle, '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.opPutReplaceSkuName({
                    data: { ids: this.selectData.map(item => item.id).join(','), task_no: this.searchParams.task_no },
                    success: (res) => {
                        if (res.code == 200) {
                            this.$message.success('过滤成功，' + res.data + 'sku')
                            this.getDataList()
                        } else {
                            this.$message.error(res.message)
                        }
                    }
                })
            })
        },
        //批量下架
        batchoffline() {
            if (this.selectData.length == 0) {
                this.$message.error('请选择下架商品');
                return
            }
            let messagetitle = `是否确定下架${this.selectData.length}个异常sku的云商品?`
            this.$confirm(messagetitle, '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.opOfflineSkudetection({
                    data: { ids: this.selectData.map(item => item.id).join(',') },
                    success: (res) => {
                        if (res.code == 200) {
                            this.$message.success('下架成功，' + res.data + '个商品')
                            this.getDataList()
                        } else {
                            this.$message.error(res.message)
                        }
                    }
                })
            })
        },
        // 切割 | 成数组
        formatRemark(remark, sku_amount_abnormal_remark) {
            // 两个都为空直接返回空数组
            if (!remark && !sku_amount_abnormal_remark) return []

            let appendStr = ''
            if (sku_amount_abnormal_remark) {
                try {
                    // 解析JSON数组
                    const list = JSON.parse(sku_amount_abnormal_remark)
                    const arr = []
                    for (const item of list) {
                        // 拼接指定字段
                        // const text = `SKU_ID:${item.SKU_ID},SKU规格:${item["SKU规格"]},官方风险分类:${item["官方风险分类"]},违规原因:${item["违规原因"]},混卖信号:${item["混卖信号"]}`
                        const text = `SKU_ID:${item.SKU_ID},违规原因:${item["违规原因"]}`
                        arr.push(text)
                    }
                    appendStr = arr.join('|')
                } catch (e) {
                    // JSON解析失败不追加内容
                    appendStr = ''
                }
            }

            // 合并原有remark和异常备注
            const temp = []
            if (remark) temp.push(remark.trim())
            if (appendStr) temp.push(appendStr)
            const fullRemark = temp.join('|')

            // 分割、过滤空项返回
            return fullRemark.split('|').filter(item => item.trim() !== '')
        },
        getViolationWords() {
            this.opGetViolationWords({
                data: {},
                success: (res) => {
                    if (res.code == 200) {
                        this.name_words_options = res.data.sku_name_abnormal_words
                        this.size_words_options = res.data.sku_size_abnormal_words
                    } else {
                        this.$message.error(res.message)
                    }
                }
            })
        },
        // 失去焦点查询
        change_search(change) {
            if (!change) {
                // 加个延时 200ms，防止连续触发
                clearTimeout(this.blurTimer)
                this.blurTimer = setTimeout(() => {
                    this.getDataList() // 执行你的查询接口
                }, 200)
            }

        },
        // 打开单条编辑
        handleEdit(row) {
            this.cloudEditMode = 'single'
            this.cloudEditList = [row]
            this.cloudEditShow = true
        },
        // 打开批量编辑
        handleCloudBatchEdit() {
            this.cloudEditMode = 'batch'
            this.cloudEditList = [...this.selectData]
            this.cloudEditShow = true
        },
        // 关闭弹窗重置数据
        handleCloudEditClose() {
            this.cloudEditDirty = false
            this.cloudEditMode = 'single'
            this.cloudEditList = []
            this.cloudEditShow = false
        },

    }
}
</script>


<style scoped>
.w_120 {
    width: 150px;
}

.text-ellipsis-multi {
    line-height: 1.4;
    max-height: 60px;
    overflow: hidden;
    text-align: left;
}

/* 商品信息样式 */
.goods-box {
    display: flex;
    align-items: flex-start;
    width: 100%;
    /*max-width: 280px;*/
    /* 限制最大宽度 */
    flex: 1;
}

.goods-img {
    width: 50px;
    height: 50px;
    object-fit: cover;
    margin-right: 8px;
    border-radius: 4px;
    flex-shrink: 0;
    /* 防止图片被压缩 */
}

.goods-info {
    flex: 1;
    font-size: 12px;
    line-height: 1.5;
    min-width: 0;
    /* 允许内容收缩 */
    overflow: hidden;
}

.goods-info>div {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    margin-bottom: 2px;
}

.goods-title {
    font-size: 11px;
    font-weight: 600;
    color: rgb(26, 26, 46);
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    max-width: 160px;
    /* 标题允许换行 */
    margin-bottom: 4px;
}


.notFond-tag {
    color: #999999;
    font-size: 10px;
    margin-top: 2px;
}

.selected-tag {
    color: #E6A23C;
    font-size: 10px;
    margin-top: 2px;
}

.offline-tag {
    color: #e71b1b;
    font-size: 10px;
    margin-top: 2px;
}

.replaced-tag {
    color: #67c23a;
    font-size: 10px;
    margin-top: 2px;
    font-weight: bold;
}

.remark-multi-line {
    text-align: left;
    line-height: 1.5;
    max-height: 4.5em;
    /* 刚好3行 */
    overflow: hidden;
    color: rgb(200, 68, 60);
}

.remark-multi-line>div {
    white-space: nowrap;
    overflow: hidden;
}

/* ══ 筛选区白色卡片 ══ */
.ra-filter {
    background: #FFFFFF;
    border: 1px solid #ECEEF2;
    border-radius: 10px;
    padding: 14px 16px;
    margin-bottom: 14px;
}
.ra-filter-opt{
  display: flex;
  align-items: center;
  gap: 7px;
  margin-top: 8px;
}
.ra-filter-opt .btn~.btn{
  margin-left: 0;
}
.btn--danger{
  background: rgba(248, 113, 113, 0.07);
  border: 1px solid rgb(255, 204, 199);
  color: rgb(248, 113, 113);
}
.btn--danger:hover{
  background: rgba(248, 113, 113, 0.18);
}
.ra-filter__row {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    gap: 10px 14px;
}
.ra-filter__row--btns {
    margin-top: 12px;
    padding-top: 12px;
}
.ra-filter__item {
    display: flex;
    align-items: center;
    gap: 6px;
}
.ra-filter__label {
    font-size: 12px;
    color: #6A6A8A;
    white-space: nowrap;
}
.ra-filter__input {
    width: 120px;
}
.ra-filter__select {
    width: 150px;
}
.ra-filter__divider {
    width: 1px;
    height: 18px;
    background: #E4E7ED;
    margin: 0 4px;
}

.table-pager-wrap{
  background: rgb(255, 255, 255);
  border-radius: 8px;
  border: 2px solid rgb(224, 224, 236);
  overflow: hidden;
  box-shadow: rgba(0, 0, 0, 0.04) 0px 1px 3px;
}
/* ══ 按钮 ══ */

/* ══ 商品图片圆角框 ══ */
.ra-goods__imgwrap {
    width: 52px;
    height: 52px;
    border-radius: 8px;
    background: #F7F8FA;
    border: 1px solid #EEE;
    overflow: hidden;
    flex-shrink: 0;
    margin-right: 10px;
    display: flex;
    align-items: center;
    justify-content: center;
}
.ra-goods__imgwrap .goods-img {
    width: 44px;
    height: 44px;
    margin-right: 0;
    border-radius: 6px;
}

.skuStatus-wait{
    padding: 1px 5px;
    border-radius: 3px;
    background: rgb(255, 247, 230);
    border: 1px solid rgb(255, 213, 145);
    font-size: 9px;
    font-weight: 500;
    color: rgb(251, 146, 60);
    width: fit-content;
}
.skuStatus-success{
    padding: 1px 5px;
    border-radius: 3px;
    background: rgb(246, 255, 237);
    border: 1px solid rgb(183, 235, 143);
    font-size: 9px;
    font-weight: 500;
    color: rgb(82, 196, 26);
    width: fit-content;
}
.skuStatus-error{
    padding: 1px 5px;
    border-radius: 3px;
    background: rgb(245, 245, 245);
    border: 2px solid rgb(224, 224, 236);
    font-size: 9px;
    font-weight: 500;
    color: rgb(153, 153, 153);
    width: fit-content;
}
/* ══ SKU状态小标签 ══ */
.selected-tag,
.replaced-tag,
.notFond-tag {
    display: inline-block;
    padding: 1px 8px;
    border-radius: 4px;
    font-size: 10px;
    margin-top: 2px;
    font-weight: 500;
}
.offline-tag {
    color: #F56C6C;
    font-size: 10px;
    margin-top: 2px;
}

/* ══ 检测编号列青色（仅表体） ══ */
::v-deep(.el-table__body .ra-col-no .cell) {
    color: rgb(63, 182, 224);
}

/* ══ 分页栏：左总数/每页条数 · 中页码 · 右跳转 ══ */
.ra-pager {
    display: grid;
    grid-template-columns: 1fr auto 1fr;
    align-items: center;
    gap: 12px;
    padding: 10px 14px;
    background: rgb(245, 240, 232);
    font-size: 13px;
    color: #606266;
}
.ra-pager__col {
    display: flex;
    align-items: center;
    gap: 8px;
}
.ra-pager__col--left { justify-content: flex-start; }
.ra-pager__col--center { justify-content: center; }
.ra-pager__col--right { justify-content: flex-end; }
.ra-pager__num {
    color: rgb(26, 26, 46);
    font-weight: 600;
}
.ra-pager__jump {
    display: inline-flex;
    align-items: center;
    gap: 4px;
    color: #606266;
}
.ra-pager__input {
    width: 36px;
    height: 24px;
    border: 1px solid #dcdfe6;
    border-radius: 4px;
    padding: 0 6px;
    font-size: 13px;
    outline: none;
    color: #303133;
    text-align: center;
    background: #FFFFFF;
}
.ra-pager__input:focus { border-color: #f56c6c; }
.ra-pager__ok {
    height: 24px;
    padding: 0 10px;
    border-radius: 4px;
    border: 1px solid rgb(200, 68, 60);
    background: rgb(255, 245, 245);
    color: rgb(200, 68, 60);
    font-size: 12px;
    cursor: pointer;
    transition: background .15s;
}
.ra-pager__ok:hover {
    background: rgb(200, 68, 60);
    color: #FFFFFF;
}
/*.ra-pager ::v-deep(.el-pagination .el-pager li) {
    background: #f5f7fa;
    color: #606266;
    border: none;
    border-radius: 4px;
    margin: 0 2px;
    font-weight: 500;
    min-width: 32px;
    height: 32px;
    line-height: 32px;
}
.ra-pager ::v-deep(.el-pagination.is-background .el-pager li:not(.disabled).active) {
    background: rgb(255, 245, 245);
    border: 1px solid rgb(200, 68, 60);
    color: rgb(200, 68, 60);
}
.ra-pager ::v-deep(.el-pagination .el-pager li:hover) {
    color: #f56c6c;
}
.ra-pager ::v-deep(.el-pagination .btn-prev),
.ra-pager ::v-deep(.el-pagination .btn-next) {
    background: #f5f7fa;
    color: #606266;
    border-radius: 4px;
    min-width: 32px;
    height: 32px;
    line-height: 32px;
}
.ra-pager ::v-deep(.el-pagination .btn-prev:hover),
.ra-pager ::v-deep(.el-pagination .btn-next:hover) {
    color: #f56c6c;
}*/

::v-deep .el-select__tags {
    flex-wrap: nowrap !important;
    /* 不换行 */
}

::v-deep .el-select__tags-text {
    display: inline-block;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}

::v-deep .el-select__input {
    width: auto !important;
    min-width: 30px !important;
}
</style>
